












































































































































































































































































































































import { defineComponent, computed, useRouter } from "@nuxtjs/composition-api";
import { useSlickOptions } from "~/stores/extensionApi";
import LazyComponent from "v-lazy-component/vue2";
import SwiperCarousel from "~/components/SwiperCarousel.vue";
import BannerList from "~/components/BannerList.vue";

import SkeletonPlaceholder from "~/components/SkeletonPlaceholder.vue";
import { useCategoryStore } from "~/modules/catalog/category/stores/category";
import { getUrlPathByCategory } from "~/modules/catalog/category/helpers";
import ProductLoadItem from "~/components/SkeletonLoader/ProductLoadItem.vue";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";

import CategoryProductSlide from "~/modules/catalog/category/components/views/CategoryProductSlide.vue";

import CategoryProductFace  from "~/modules/catalog/category/components/views/CategoryProductFace.vue";

export default defineComponent({
  name: "ProductCate",
  components: {
    SkeletonPlaceholder,
    SwiperCarousel,
    BannerList,
    LazyComponent,
    ProductLoadItem,
    SkeletonLoader,
    CategoryProductFace,
    CategoryProductSlide,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
  },

  setup() {
    const router = useRouter();
    const slickOptions = useSlickOptions();
    const categoryStore = useCategoryStore();
    const categoryTree = computed(() => categoryStore.categories);

    const BannerOptions = {
      slidesPerView: 1,
      pagination: { clickable: true },
      navigation: true,
      loop: true,
    };

    const OptionItemProductRight = {
      slidesPerView: 2.3,
      slidesPerGroup: 2,
      spaceBetween: 16,
      centeredSlides: false,
      loop: false,
      pagination: { clickable: true },
      navigation: true,
      breakpoints: {
        640: {
          slidesPerView: 2.3,
          slidesPerGroup: 2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 3.2,
          slidesPerGroup: 3,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 2.7,
          slidesPerGroup: 2,
          spaceBetween: 32,
        },
      },
    };
    const OptionItemProductDefaul = {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 16,
      centeredSlides: false,
      loop: false,
      pagination: { clickable: true },
      navigation: true,
      slidesPerColumn: 2,
      slidesPerColumnFill: "row",
      breakpoints: {
        640: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 16,
          slidesPerColumn: 2,
          slidesPerColumnFill: "row",
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 16,
          slidesPerColumn: 2,
          slidesPerColumnFill: "row",
        },
        1024: {
          slidesPerView: 2.7,
          slidesPerGroup: 2,
          spaceBetween: 32,
          slidesPerColumn: 1,
          slidesPerColumnFill: "row",
        },
      },
    };

    const OptionItemProduct = {
      slidesPerView: 2.3,
      slidesPerGroup: 2,
      spaceBetween: 16,
      centeredSlides: false,
      loop: false,
      pagination: { clickable: true },
      navigation: true,
      breakpoints: {
        640: {
          slidesPerView: 2.3,
          slidesPerGroup: 2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 3.2,
          slidesPerGroup: 3,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 32,
        },
      },
    };

    const goToCateById = async (row) => {
      const url_path = getUrlPathByCategory(row, categoryTree.value);
      if (url_path) {
        router.push(`/${url_path}`);
      }
    };

    return {
      BannerOptions,
      goToCateById,
      OptionItemProductRight,
      OptionItemProduct,
      OptionItemProductDefaul,
    };
  },
});
